exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".img-reported[data-v-2de54788]{border:1px solid #eee;padding:10px;margin:10px;max-width:100px;max-height:100px}.list[data-v-2de54788]{border-bottom:3px solid #000;padding-bottom:20px;margin-bottom:30px;display:block;list-style:circle}", ""]);

// exports
